import { render, staticRenderFns } from "./teacherAnimation.vue?vue&type=template&id=6828c043&scoped=true&"
import script from "./teacherAnimation.vue?vue&type=script&lang=js&"
export * from "./teacherAnimation.vue?vue&type=script&lang=js&"
import style0 from "./teacherAnimation.vue?vue&type=style&index=0&id=6828c043&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828c043",
  null
  
)

export default component.exports